const topics = [
  {
    id: "1",
    topics_name: "Нэр томьёо ба тодорхойлолт",
    question_number: "10",
  },
  {
    id: "2",
    topics_name: "Механикжсан тээврийн хэрэгслийн ангилал",
    question_number: "10",
  },
  {
    id: "3",
    topics_name: "Замын тэмдэг ба тэмдэглэл",
    question_number: "40",
  },
  {
    id: "4",
    topics_name: "Анхааруулах дохио ба таних тэмдэг",
    question_number: "20",
  },
  {
    id: "5",
    topics_name: "Тээврийн хэрэгсэл байрлан явах",
    question_number: "20",
  },
  {
    id: "6",
    topics_name: "Тээврийн хэрэгслийн хурд",
    question_number: "10",
  },
  {
    id: "7",
    topics_name: "Түр ба удаан зогсох",
    question_number: "10",
  },
  {
    id: "8",
    topics_name: "Төмөр замын гарам нэвтрэх",
    question_number: "10",
  },
  {
    id: "9",
    topics_name: "Механикжсан тээврийн хэрэгслийг чирэх",
    question_number: "10",
  },
  {
    id: "10",
    topics_name: "Хүн тээвэрлэх",
    question_number: "20",
  },
  {
    id: "11",
    topics_name: "Ачаа тээвэрлэх",
    question_number: "20",
  },
  {
    id: "12",
    topics_name: "Тээврийн хэрэгслийн эвдрэл, гэмтэл, техникийн зөрчил",
    question_number: "10",
  },
  {
    id: "13",
    topics_name: "Тээврийн хэрэгслийг аюулгүй жолоодох онол",
    question_number: "10",
  },
];

export default topics;
